import Vue from "vue";
import isEqual from "lodash/isEqual";
import invert from "lodash/invert";
import clone from "lodash/clone";

export const SET_IMPORT = (state, row) => {
  state.import = row;
};

export const SET_ROWS = (state, rows) => {
  state.parsedCsv = rows;
};

export const SET_COLUMNS = (state, data) => {
  state.columns = data;
};

export const NEXT_STEP = (state) => {
  if (state.activeStep === state.pages.length - 1) return;
  state.activeStep++;
};

export const PREVIOUS_STEP = (state) => {
  if (state.activeStep === 0) return;
  state.activeStep--;
};

export const SET_ACTIVE_STEP = (state, activeStep) => {
  Vue.set(state, "activeStep", activeStep);
};

export const SET_SETUP_PROGRESS = (state, bool) => {
  Vue.set(state, "setupProgress", bool);
};

export const MATCH_COLUMN = (state, { column, match }) => {
  Vue.set(state.matches, match, column);
};

// Gene Mutations

export const SET_HYDRATION_STATUS = (state, bool) => {
  state.hasHydration = bool;
};

export const SET_SUGGESTED_COLUMNS = (state, data) => {
  state.suggestedColumns = data.clubData;
};

export const SET_PARSED_COLUMNS = (state, { clubData, importData }) => {
  if (!Object.entries(state.matchedColumns).length)
    state.matchedColumns = invert(importData.matched);

  if (!state.suggestedColumns.length) state.suggestedColumns = clubData;

  let entries = Object.entries(state.matchedColumns);

  state.unique.columns = importData.original.reduce((acc, column) => {
    let matchedEntry = entries.findIndex(([key, value]) => value === column);
    let colObj = {
      value: column,
      matchedValue: matchedEntry !== -1 ? entries[matchedEntry][0] : "",
      status: matchedEntry !== -1 ? "matched" : "unknown",
    };
    acc.push(colObj);
    return acc;
  }, []);
};

export const SET_HAS_TEAM_DATA = (state, bool) => {
  state.hasTeamData = bool;
};

export const SET_HAS_POSITION_DATA = (state, bool) => {
  state.hasPositionData = bool;
};

export const SET_TEAMS = (state, teams) => {
  state.clubTeams = [];
  teams.forEach((team) => {
    state.clubTeams.push({ label: team.name, value: team.name, id: team.id });
  });
};

export const SET_UNIQUE_TEAMS = (state, data) => {
  Vue.set(state.unique, state.matchedColumns.team_assignment, data);
};

export const SET_POSITIONS = (state, clubData) => {
  Vue.set(state, "clubPositions", clubData);
};

export const SET_UNIQUE_POSITIONS = (state, data) => {
  Vue.set(state.unique, state.matchedColumns.position, data);
};

export const SET_PARSED_CSV = (state, data) => {
  state.parsedCsv = data;
};

export const SET_EDIT_DATA = (state, data) => {
  Vue.set(state, "editData", data);
};

export const SET_ATHLETE_OBJ = (state, data) => {
  state.athleteArr = [...data];
};

export const SET_CLUB_EXISTING_ATHLETES = (state, athletes) => {
  state.existingAthletes = athletes;
};

export const SET_CSV_COLUMNS = (state) => {
  if (state.parsedCsv.status === "loaded") {
    let columns = Object.keys(state.parsedCsv.data[0]);

    state.unique.columns = columns.map((col) => ({
      value: col,
      matchedValue: "",
      status: "unknown",
    }));
  }
};

export const FILTER_UNIQUE_EDIT_DATA = (state, column) => {
  if (!column) return;
  let unique = new Set();
  state.editData
    .filter((data) => data.column === column)
    .forEach((data) =>
      Array.isArray(data.value)
        ? data.value.forEach((d) => unique.add(d))
        : data.value && unique.add(data.value)
    );

  let uniqueData = Array.from(unique).map((data) => ({
    value: data,
    matchedValue: "",
    status: "unknown",
  }));
  Vue.set(state.unique, column, uniqueData);
};

export const REMOVE_COLUMN = (state, col) => {
  state.unique.columns = state.unique.columns.filter(
    (c) => c.value !== col.csvData
  );
};

export const UPDATE_EDIT_DATA = (state, data) => {
  let idx = state.editData.findIndex(
    (d) => d.id === data.id && d.column === data.column
  );
  Vue.set(
    state.editData,
    idx,
    Object.assign({}, state.editData[idx], {
      value: data.newData,
      status: data.status,
    })
  );
};

export const UPDATE_UNIQUE = (state, { key, id, status, editedData }) => {
  Vue.set(state.unique[key][id], "status", status);
  if (editedData) Vue.set(state.unique[key][id], "matchedValue", editedData);
};

export const CLEAR_MATCHED_VALUE = (state, { key, id }) => {
  Vue.set(state.unique[key][id], "matchedValue", null);
};


export const setProcessingStatus = (state, { idx, status, objKey }) => {
  Vue.set(state.processingAll, objKey, { status: status });
};

export const SET_MATCHED_COLUMNS = (state) => {
  state.matchedColumns = state.unique.columns.reduce((acc, col) => {
    if (col.matchedValue) {
      acc[col.matchedValue] = col.value;
    }
    return acc;
  }, {});
};

export const REMOVE_EDIT_DATA = (state, id) => {
  !state.removedEditData.includes(id) &&
    (state.removedEditData = state.removedEditData.concat(id));
};

// FINAL REVIEW

// export const SET_ATHLETE_OBJ_STATUS = (state, { index, status }) => {
//   state.athleteArr[index] = { ...state.athleteArr[index], status: status };
// };
export const SET_REMOVED_ATHLETES = (state, data) => {
  Vue.set(state, "removedAthletes", data);
};

export const SET_REMOVED_FROM_ROSTER = (state, data) => {
  Vue.set(state, "removedFromRoster", data);
};

export const REMOVE_ATHLETE = (state, entry) => {
  let newArr = clone(state.removedFromRoster).concat(entry);
  Vue.set(state, "removedFromRoster", newArr);
};

export const KEEP_ATHLETE = (state, entry) => {
  const keep = state.removedFromRoster.filter((athlete) => {
    return !isEqual(athlete, entry);
  });
  Vue.set(state, "removedFromRoster", keep);
};

export const SET_SUBMIT_ROSTER = (state, payload) => {
  state.submitRoster = payload;
};

export const SET_HAS_FETCHED = (state, payload) => {
  state.hasFetchedAthletes = payload;
};

export const SET_HAS_CHOSEN_IMPORT_TYPE = (state, payload) => {
  state.hasChosenImportType = payload;
};

export const SET_PREVIOUS_IMPORTS = (state, payload) => {
  state.previousImports = payload;
};

export const SET_IS_LOADING_PREVIOUS_IMPORTS = (state, payload) => {
  state.isLoadingPreviousImports = payload;
};

export const SET_DISABLE_CONTINUE_BUTTON = (state, payload) => {
  state.disableContinueButton = payload;
};

export const SET_IS_RESOLVING_ATHLETES_WITH_MISSING_EMAILS = (state, payload) => {
    state.isResolvingAthletesWithMissingEmails = payload;
};

export const SET_TOTAL_ATHLETES_WITH_MISSING_EMAILS_BEING_RESOLVED = (state, payload) => {
    state.totalAthletesWithMissingEmailsBeingResolved = payload;
};

export const SET_HAS_MATCHED_TEAMS = (state, payload) => {
  state.hasMatchedTeams = payload;
};

export const SET_HAS_MATCHED_POSITIONS = (state, payload) => {
  state.hasMatchedPositions = payload;
};

export const SET_UPLOADING_STATUS = (state, bool) => {
  state.isUploadingImport = bool;
};

export const SET_IMPORT_UPLOAD_ERRORS = (state, errors) => {
  state.importUploadErrors = errors;
};
